var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvaxcIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#E3453D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1018 25.4315C31.5159 24.39 30.5785 24.39 29.9926 25.4315L26.2932 31.9701C25.7073 32.9944 26.1927 33.848 27.3478 33.848H34.6797C35.8515 33.848 36.3369 32.9944 35.7511 31.9701L32.1018 25.4315Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8167 17.732L25.8916 14.2663L25.0714 12.7811C24.4855 11.7396 23.5481 11.7396 22.9622 12.7811L12.2488 31.9532C11.6629 32.9945 12.1484 33.8311 13.3202 33.8311H16.2998H18.342H18.6936C19.6645 33.8311 20.8697 33.1311 21.3552 32.2605L27.8167 20.8562C28.2854 20.0197 28.2854 18.6027 27.8167 17.732Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvaxcIcon);
export default __webpack_public_path__ + "static/media/avaxcIcon.195710d8.svg";
export { ForwardRef as ReactComponent };